class FeaturedCollectionCarousel extends HTMLElement {
  constructor() {
    super();

    this.limit = this.dataset.limit || 1
  }

  connectedCallback() {
    this._initSlide()
  }

  _initSlide() {
    const swiperEl = this.querySelector('.js-featured-collection-carousel')
    const prevEl = this.querySelector('.featured-collection--icon-previous')
    const nextEl = this.querySelector('.featured-collection--icon-next')
    const option = {
      init: false,
      draggable: true,
      crossFade: true,
      spaceBetween: 15,
      slidesPerView: 1.2,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerGroup: 1,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        640: {
          slidesPerView: 2.2,
          slidesPerGroup: 2,
        },
        990: {
          slidesPerView: 3.25,
          spaceBetween: 20,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          slidesPerGroup: 3,
        },
        1400: {
          slidesPerView: 4.25,
          spaceBetween: 20,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          slidesPerGroup: 4,
        },
        1800: {
          slidesPerView: 5.2,
          spaceBetween: 20,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          slidesPerGroup: 5,
        }
      },
    }

    this.$swiper = new Swiper(swiperEl, option)
    this.$swiper.on('afterInit', (swiper) => this._doInit())
    this.$swiper.on('resize', (swiper) => {
      this._doInit()
    })
    this.$swiper.init()
  }

  _doInit() {
    const imgWrapper = this.$swiper.el.querySelector(
      '.card__media',
    )
    if (imgWrapper) {
      const h = imgWrapper.getBoundingClientRect().height
      this.style.setProperty('--media-height', `${h}px`)
    }

    const slides = this.$swiper.el.querySelectorAll('.swiper-slide').length || 1
    if(window.innerWidth < 639) {
      if(slides === 1) {
        this.$swiper.disable()
      } else {
        this.$swiper.enable()
      }
    } else if(window.innerWidth < 989) {
      if(slides < 3) {
        this.$swiper.disable()
      } else {
        this.$swiper.enable()
      }
    } else if(window.innerWidth < 1399) {
      if(slides < 4) {
        this.$swiper.disable()
      } else {
        this.$swiper.enable()
      }
    } else if(window.innerWidth < 1799) {
      if(slides < 5) {
        this.$swiper.disable()
      } else {
        this.$swiper.enable()
      }
    } else {
      if(slides < 6) {
        this.$swiper.disable()
      } else {
        this.$swiper.enable()
      }
    }
  }

  _destroySlide() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }

  disconnectedCallback() {
    this._destroySlide()
  }
}

if (typeof customElements.get('featured-collection-carousel') === 'undefined') {
  customElements.define('featured-collection-carousel', FeaturedCollectionCarousel);
}
